module.exports = __webpack_public_path__ + "img/location.1b163143.svg";